import { useState } from 'react';
import { useLocation } from 'react-router';

import { Header, Navbar } from '../../../main/index.js';
import { UpdateHandler } from '../../interface/index.js';

interface Props {
    hideChrome?: boolean;
    children: any;
}

const loginRoutes = ['/login', '/signup', '/forgot-password'];

const SiteChrome: FC<Props> = ({ children, hideChrome }) => {
    const [navbarExpanded, setNavbarExpanded] = useState(false);
    const location = useLocation();
    const onLogin = loginRoutes.includes(location.pathname);

    if (hideChrome) return children;

    return (
        <>
            {APP ? null : <UpdateHandler />}
            {onLogin ? null : <Header navExpanded={navbarExpanded} />}
            {children}
            <Navbar expanded={navbarExpanded} setExpanded={setNavbarExpanded} onLogin={onLogin} />
        </>
    );
};

export default SiteChrome;
